'use client';

import { createContext, useContext, type ReactNode } from 'react';

const TabScopeContext = createContext<string | undefined>(undefined);

interface TabScopeProviderProps {
  scopeId: string | undefined;
  children: ReactNode;
}

export function TabScopeProvider({ scopeId, children }: TabScopeProviderProps) {
  return (
    <TabScopeContext.Provider value={scopeId}>
      {children}
    </TabScopeContext.Provider>
  );
}

export function useTabScope(): string | undefined {
  return useContext(TabScopeContext);
}
